// Wait for document ready
document.addEventListener('DOMContentLoaded', function() {
  // Get all images
  var images = document.querySelectorAll('.masthead-parallax');
  // Initialize Simple Parallax
  new SimpleParallax(images, {
    orientation: 'down',
    scale: 1.2,
  });
});

// Wait for document ready
document.addEventListener('DOMContentLoaded', function() {
  // Get all images
  var images = document.querySelectorAll('.text-and-image-parallax');
  // Initialize Simple Parallax
  new SimpleParallax(images, {
    orientation: 'down',
    scale: 1.2,
  });
});
